import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Props:
//   roles    — exact role list (any match)
//   minRole  — minimum role level in hierarchy
const PrivateRoute = ({ children, roles, minRole }) => {
  const { isAuthenticated, hasRole, hasMinRole } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const roleOk = (!roles || hasRole(...roles)) && (!minRole || hasMinRole(minRole));

  if (!roleOk) {
    return (
      <div className="container py-5 text-center">
        <div className="text-danger mb-3">
          <i className="bi bi-shield-x" style={{ fontSize: '3rem' }}></i>
        </div>
        <h4>Access Denied</h4>
        <p className="text-muted">You don't have permission to view this page.</p>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
